module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-douwe-egberts-00.1@2x.442b2b8a.jpg";